import { environment } from "../environment";

export type AppRegion = (typeof environment)["VITE_REGION"];

export const getAppRegion = (): AppRegion => environment.VITE_REGION;

export const isApacRegion = (): boolean => environment.VITE_REGION === "ap";
